import { PasswordUpdateForm } from './PasswordUpdateForm';

export default PasswordUpdateForm;
